import { canProvisionFreeDashTeam } from "@mirage/service-provisioning";
import Sentry from "@mirage/shared/sentry";
import { useCallback, useState } from "react";
import { RedirectVariant } from "../types";

export const isOnWebOnboarding = (pathname: string, protocol: string) => {
  // allow /authconfirm so users can create connections during onboarding
  return (
    pathname.toLowerCase().includes("/authconfirm") ||
    // Always show for desktop
    (pathname.toLowerCase().includes("/setup") &&
      protocol.toLowerCase().startsWith("http"))
  );
};

export const useWebOnboardingEligibility = () => {
  const [canCreateFreeDashTeam, setCanCreateFreeDashTeam] = useState<
    boolean | null
  >(null);

  const meetsDashOnboardingEligibilityCriteria = useCallback(
    async (variant: RedirectVariant): Promise<boolean> => {
      if (variant === RedirectVariant.DfbOnboarding) {
        return true;
      }

      if (canCreateFreeDashTeam !== null) {
        return canCreateFreeDashTeam;
      }

      try {
        const result = await canProvisionFreeDashTeam();
        setCanCreateFreeDashTeam(result);
        return result;
      } catch (error) {
        Sentry.captureException(error);
        setCanCreateFreeDashTeam(false);
        return false;
      }
    },
    [canCreateFreeDashTeam],
  );

  return {
    meetsDashOnboardingEligibilityCriteria,
  };
};
